import { Stack } from '@mui/material';
import type { InventoryResource, Snapshot } from '@repo/api-gw-sdk';

import type { BackupVault } from '@/data/vaults/backupVault';

import type { MutateSnapshots } from './eonSnapshotsTab';
import { SnapshotActionsGroup } from './snapshotActionsGroup';
import { SnapshotDetailsHeader } from './snapshotDetailsHeader';

export const SnapshotRow = ({
  snap,
  vault,
  isSelected,
  onSelect,
  onRestore,
  resource,
  snapshotSelection,
  mutateSnapshots,
}: {
  snap: Snapshot;
  vault: BackupVault | undefined;
  isSelected: boolean;
  onSelect: () => void;
  onRestore?: () => void;
  volume?: string;
  resource: InventoryResource;
  snapshotSelection: boolean;
  mutateSnapshots: MutateSnapshots;
}) => {
  return (
    <Stack
      key={snap.id}
      gap='12px'
      data-testid='snapshot-row'
      borderBottom='1px solid var(--mui-palette-divider)'
      className='py-[24px] px-[40px] w-full'
      direction='row'
      justifyContent='space-between'
      alignItems='center'
    >
      <SnapshotDetailsHeader
        snap={snap}
        vault={vault}
        onSelect={onSelect}
        isSelected={isSelected}
        snapshotSelection={snapshotSelection}
        resource={resource}
      />
      <SnapshotActionsGroup
        snap={snap}
        isVisible={!snapshotSelection || isSelected}
        onRestore={onRestore}
        resource={resource}
        mutateSnapshots={mutateSnapshots}
      />
    </Stack>
  );
};
